import Plaid, { PlaidButton } from './components/Plaid';

export default (editor, opts = {}) => {
  const dc = editor.DomComponents;
  const bm = editor.BlockManager;
  const { labels, types, labelShoppingCartCategory } = opts;
  PlaidButton(bm, labelShoppingCartCategory, labels.plaidButton, types.plaidButton);
  Plaid(dc, labels.plaidButton, types.plaidButton, opts);
};
